import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})

export class CausasRaizService {

  private apiUrl = environment.apiUrl;
  causasUrl = `${this.apiUrl}public/causas-raiz/`;

  constructor(private _http: HttpClient) {
  }

  getCausasEmpresa(empresaId): Observable<any[]> {
    return this._http.get(`${this.causasUrl}empresa/${empresaId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  getCausasLoja(lojaId, empresaId): Observable<any[]> {
    return this._http.get(`${this.causasUrl}loja/${empresaId}/${lojaId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  getCausasUsuario(usuarioId, empresaId): Observable<any[]> {
    return this._http.get(`${this.causasUrl}usuario/${empresaId}/${usuarioId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  insertCausa(empresaId, causa) {
    return this._http.post(`${this.causasUrl}causa/${empresaId}`, causa)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertCausas(empresaId, causas) {
    return this._http.post(`${this.causasUrl}causas/${empresaId}`, causas)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  removeCausas(empresaId, arrayIds): Observable<any[]> {
    const ids = JSON.stringify(arrayIds);
    return this._http.delete(`${this.causasUrl}${empresaId}/${ids}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getCausasByDimensao(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.causasUrl}causasByDimensaoEmpresa/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
